<!--
  ~ Copyright © 2018 DV Bern AG, Switzerland
  ~
  ~ Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
  ~ geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
  ~ insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
  ~ elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
  ~ Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
  -->

@if (pdfGeneratorService.inProgress()) {
    <ng-progress #progressbar></ng-progress>
    <elohn-print-progress-toolbar (abortClicked)="pdfGeneratorService.abort()"
                                  [completedCount]="completedCount()"
                                  [queueSize]="queueSize()"/>
} @else if ((hasMarks$ | async) === true) {
    <elohn-marker-toolbar/>
} @else {
    <elohn-default-toolbar/>
}
